import { Pagination, Table } from 'react-bootstrap';
import styled from 'styled-components';
import { useTable, usePagination } from 'react-table';
import { useDispatch, useSelector } from 'react-redux';
import { Fragment, useEffect, useMemo } from 'react';
import { VscLoading } from 'react-icons/vsc';
import { clearTable } from '../../Redux/slices/table';

const ReactTable = ({ columns, data, dataFetcher, showGoto = true }) => {
  const pageNum = useSelector((state) => state.table.pageNum);
  const loading = useSelector((state) => state.table.loading);
  const totalCount = useSelector((state) => state.table.totalCount);
  const dispatch = useDispatch();
  const {
    headerGroups,
    getTableProps,
    getTableBodyProps,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex, pageSize }
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 50 },
      manualPagination: true,
      pageCount: pageNum
    },
    usePagination
  );

  useEffect(() => {
    dataFetcher({ index: pageIndex, pageSize: pageSize });
  }, [pageIndex, pageSize]);
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);

  const pageCountArray = useMemo(
    () => Array.from({ length: Math.ceil(totalCount / pageSize) }, (v, i) => i + 1),
    [totalCount]
  );

  return (
    <div>
      <StyledPagination>
        <div>
          {!loading && (
            <span className="text-secondary">
              Showing {page.length} of {totalCount} results
            </span>
          )}
        </div>
        <div className="d-flex">
          <Pagination>
            <Pagination.First onClick={() => gotoPage(0)} disabled={!canPreviousPage} />
            <Pagination.Prev onClick={() => previousPage()} disabled={!canPreviousPage} />
            {pageCount < 6 ? (
              pageCountArray
                .filter((count, index) => index < 5)
                .map((count) => (
                  <Fragment key={count}>
                    <Pagination.Item
                      active={count === pageNum}
                      key={count}
                      onClick={() => gotoPage(count)}>
                      {count}
                    </Pagination.Item>
                  </Fragment>
                ))
            ) : (
              <>
                <Pagination.Item>...</Pagination.Item>
                <Pagination.Item onClick={() => gotoPage(pageNum - 2)}>
                  {pageNum - 2}
                </Pagination.Item>
                <Pagination.Item onClick={() => gotoPage(pageNum - 1)}>
                  {pageNum - 1}
                </Pagination.Item>

                <Pagination.Item active>{pageNum}</Pagination.Item>

                <Pagination.Item onClick={() => gotoPage(pageNum + 1)}>
                  {pageNum + 1}
                </Pagination.Item>

                <Pagination.Item
                  onClick={() => (pageNum < pageCountArray.length ? gotoPage(pageNum + 2) : null)}>
                  {pageNum + 2}
                </Pagination.Item>

                <Pagination.Item>...</Pagination.Item>
              </>
            )}
            <Pagination.Next onClick={() => nextPage()} disabled={!canNextPage} />
            <Pagination.Last onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} />
          </Pagination>

          {showGoto ? (
            <div className="pagination-input_div text-muted">
              <span className="mx-2">
                Go to :{' '}
                <input
                  className="pagination-input"
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                    gotoPage(page);
                  }}
                />
              </span>
              <span> of {pageCountArray.length} page</span>
            </div>
          ) : null}
        </div>
      </StyledPagination>
      <TableContainer>
        <StyledTable {...getTableProps()} striped bordered hover>
          <thead>
            {headerGroups.map((headerGroup) => (
              // eslint-disable-next-line react/jsx-key
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  // eslint-disable-next-line react/jsx-key
                  <th {...column.getHeaderProps()}>
                    {column.render('Header')}
                    <span>{column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}</span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {loading ? (
              // Use our custom loading state to show a loading indicator
              <tr>
                <td colSpan="10000" className="text-center">
                  <VscLoading className="spin" />
                </td>
              </tr>
            ) : (
              page.map((row) => {
                prepareRow(row);
                return (
                  // eslint-disable-next-line react/jsx-key
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      // eslint-disable-next-line react/jsx-key
                      return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </StyledTable>
      </TableContainer>
      <StyledPagination>
        <div>
          {!loading && (
            <span className="text-secondary">
              Showing {page.length} of {totalCount} results
            </span>
          )}
        </div>
        <div className="d-flex">
          <Pagination>
            <Pagination.First onClick={() => gotoPage(0)} disabled={!canPreviousPage} />
            <Pagination.Prev onClick={() => previousPage()} disabled={!canPreviousPage} />
            {pageCount < 6 ? (
              pageCountArray
                .filter((count, index) => index < 5)
                .map((count) => (
                  <Fragment key={count}>
                    <Pagination.Item
                      active={count === pageNum}
                      key={count}
                      onClick={() => gotoPage(count)}>
                      {count}
                    </Pagination.Item>
                  </Fragment>
                ))
            ) : (
              <>
                <Pagination.Item>...</Pagination.Item>
                <Pagination.Item onClick={() => gotoPage(pageNum - 2)}>
                  {pageNum - 2}
                </Pagination.Item>
                <Pagination.Item onClick={() => gotoPage(pageNum - 1)}>
                  {pageNum - 1}
                </Pagination.Item>

                <Pagination.Item active>{pageNum}</Pagination.Item>

                <Pagination.Item onClick={() => gotoPage(pageNum + 1)}>
                  {pageNum + 1}
                </Pagination.Item>

                <Pagination.Item
                  onClick={() => (pageNum < pageCountArray.length ? gotoPage(pageNum + 2) : null)}>
                  {pageNum + 2}
                </Pagination.Item>

                <Pagination.Item>...</Pagination.Item>
              </>
            )}
            <Pagination.Next onClick={() => nextPage()} disabled={!canNextPage} />
            <Pagination.Last onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} />
          </Pagination>

          {showGoto ? (
            <div className="pagination-input_div text-muted">
              <span className="mx-2">
                Go to :{' '}
                <input
                  className="pagination-input"
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                    gotoPage(page);
                  }}
                />
              </span>
              <span> of {pageCountArray.length} page</span>
            </div>
          ) : null}
        </div>
      </StyledPagination>
    </div>
  );
};
export default ReactTable;

export const TableContainer = styled.div`
  overflow-x: auto;
`;

const StyledTable = styled(Table)`
  thead {
    box-shadow: 0 2px 15px 0 rgb(0 0 0 / 15%);
    th {
      font-weight: 400;
    }
  }
  tbody {
    border-top: none !important;
  }
`;

const StyledPagination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .pagination {
    margin: 0;
  }
  .pagination-input_div {
    margin-left: 0.8rem;
  }
  .pagination-input {
    width: 25%;
    border: 1px solid #c7c7c7;
    text-align: center;
    padding: 0.2rem;
    border-radius: 5px;
  }
`;
